module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "goals"
  }, [(_vm.goals) ? _c('div', [_c('definition-parser', [_c('h1', [_vm._v("Dit ga je leren")]), _c('ul', {
    staticClass: "goals-content"
  }, _vm._l((_vm.goals), function(goal) {
    return _c('li', [_vm._v(_vm._s(goal))])
  }))])], 1) : _vm._e(), (_vm.successors.length || _vm.predecessors.length) ? _c('div', {
    staticClass: "assignment-seq"
  }, [_c('hr'), (_vm.successors.length) ? [_vm._m(0), _vm._l((_vm.successors), function(assignment) {
    return _c('router-link', {
      key: assignment.id,
      staticClass: "assignment-seq__related assignment-seq__related--successor",
      attrs: {
        "to": {
          name: 'assignment',
          params: {
            assignmentId: assignment.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.$emit('close')
        }
      }
    }, [_c('img', {
      staticClass: "assignment-seq__hero",
      attrs: {
        "src": assignment.image,
        "alt": assignment.title
      }
    }), _c('span', {
      staticClass: "assignment-seq__title tag"
    }, [_vm._v(_vm._s(assignment.title))])])
  })] : _vm._e(), (_vm.predecessors.length) ? [_vm._m(1), _vm._l((_vm.predecessors), function(assignment) {
    return _c('router-link', {
      key: assignment.id,
      staticClass: "assignment-seq__related assignment-seq__related--predecessor",
      attrs: {
        "to": {
          name: 'assignment',
          params: {
            assignmentId: assignment.id
          }
        }
      },
      nativeOn: {
        "click": function($event) {
          _vm.$emit('close')
        }
      }
    }, [_c('img', {
      staticClass: "assignment-seq__hero",
      attrs: {
        "src": assignment.image,
        "alt": assignment.title
      }
    }), _c('span', {
      staticClass: "assignment-seq__title tag"
    }, [_vm._v(_vm._s(assignment.title))])])
  })] : _vm._e()], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h2', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Opdracht bereidt voor op:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h2', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Opdracht valt terug op:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74a54b59","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/elements/Goals.vue
// module id = WIlv
// module chunks = 0 1